import { GetContractedForeignBusinessResponse } from '@/services';
import {
	convertUnitTypeCodeToName,
	formatDate,
	getNoNumber,
	map,
} from '@/utils';

export const formatContractedForeignBusinessDetail = (
	input: GetContractedForeignBusinessResponse['content'][number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		typeName: convertUnitTypeCodeToName(input.type),
	};
};

export const formatContractedForeignBusinessList = (
	input: GetContractedForeignBusinessResponse
) => {
	return {
		...input,
		content: map(input.content, (data, index) =>
			formatContractedForeignBusinessDetail({
				...data,
				no: getNoNumber(input, index),
			})
		),
	};
};
